import React from "react";

const NXPen = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4339_3828)">
        <path
          d="M5 12.3732L0.5 13.6332L1.76 9.1332L10 0.933199C10.0931 0.837953 10.2044 0.762274 10.3271 0.710607C10.4499 0.658939 10.5818 0.632324 10.715 0.632324C10.8482 0.632324 10.9801 0.658939 11.1029 0.710607C11.2256 0.762274 11.3369 0.837953 11.43 0.933199L13.2 2.7132C13.2937 2.80616 13.3681 2.91677 13.4189 3.03862C13.4697 3.16048 13.4958 3.29119 13.4958 3.4232C13.4958 3.55521 13.4697 3.68592 13.4189 3.80778C13.3681 3.92964 13.2937 4.04024 13.2 4.1332L5 12.3732Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4339_3828">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.133301)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NXPen;
